package com.essntl.features.country.ui.allcountries

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.country.domain.repository.CountryRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllCountriesViewModel(
    private val countryRepository: CountryRepository,
    private val state: MutableStateFlow<AllCountriesState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AllCountriesEvent) {
        when (event) {
            is AllCountriesEvent.GetAllCountries -> getAllCountries()
            is AllCountriesEvent.AddCountry -> addCountry(event)
            is AllCountriesEvent.EditCountry -> editCountry(event)
            is AllCountriesEvent.DeleteCountry -> deleteCountry(event)
        }
    }

    private fun getAllCountries() =
        getData(
            getData = { countryRepository.getAll() },
            getState = { state.value.getAllCountries },
            setState = { newState -> state.update { it.copy(getAllCountries = newState) } },
        )

    private fun addCountry(event: AllCountriesEvent.AddCountry) =
        state.update {
            it.copy(
                getAllCountries = it.getAllCountries.copy(
                    data = it.getAllCountries.data.orEmpty() + event.c,
                ),
            )
        }

    private fun editCountry(event: AllCountriesEvent.EditCountry) =
        state.update {
            it.copy(
                getAllCountries = it.getAllCountries.copy(
                    data = it.getAllCountries.data
                        .orEmpty()
                        .map { c ->
                            if (c.id == event.c.id) event.c else c
                        },
                ),
            )
        }

    private fun deleteCountry(event: AllCountriesEvent.DeleteCountry) =
        state.update {
            it.copy(
                getAllCountries = it.getAllCountries.copy(
                    data = it.getAllCountries.data
                        .orEmpty()
                        .filter { c ->
                            c.id != event.c.id
                        },
                ),
            )
        }
}